<template>
  <div>
    <!--opening hour--->
<!--    <v-row v-if="serviceArea && serviceArea.opening_hour['time']">-->
<!--      <v-col>-->
<!--        <span-->
<!--          class="sub-header1 text-tcdc-green bold">-->
<!--          {{$t('serviceArea.openingHour')}} : {{serviceArea && serviceArea.opening_hour ? serviceArea.opening_hour['time'] : ''}} {{$t('serviceArea.hrs')}}.-->
<!--          <span v-if="!serviceArea.opening_hour['close']">{{$t('serviceArea.everyDay')}}</span>-->
<!--          <span v-if="serviceArea && serviceArea.opening_hour && (serviceArea.opening_hour.close_th || serviceArea.opening_hour.close_en)">-->
<!--            ({{ $t('serviceArea.closed') + ' ' + serviceArea.opening_hour['close_'+lang] }})-->
<!--          </span>-->
<!--&lt;!&ndash;          <span>{{$t('serviceArea.openingDay')}}</span>&ndash;&gt;-->
<!--        </span>-->
<!--      </v-col>-->
<!--    </v-row>-->

    <!-- service area title --->
    <div class="sub-header1 text-tcdc-green bold" v-if="!!location && (location.service_area_title_th || location.service_area_title_en)">
      {{ location['service_area_title_' + lang] ? location['service_area_title_' + lang] : (location.service_area_title_th ? location.service_area_title_th : location.service_area_title_en) }}
    </div>

    <!-- travel -->
    <template v-if="travelInfo.length">
      <span class="sub-header2 text-tcdc-green bold text-uppercase">{{$t('serviceArea.travel')}}</span>
      <v-layout justify-start class="mt-5 mb-3" :column="$vuetify.breakpoint.smAndDown" v-if="travelData">
        <v-flex xs12 md6 :class="{ 'pr-12': $vuetify.breakpoint.mdAndUp, 'mb-5': $vuetify.breakpoint.smAndDown }">
          <div class="d-flex flex-1 align-end my-6">
            <a v-for="(vehicle, i) in travelInfo" :key="i" @click="setTravelData(vehicle)">
              <template v-if="travel_id == vehicle.id">
                <img :src="vehicle.icon_active"
                     class="transport-logo mr-6"/>
              </template>
              <template v-else>
                <img :src="vehicle.icon_inActive"
                     class="transport-logo mr-6"/>
              </template>
            </a>
          </div>
          <p class="text-tcdc-green sub-header2 bold">{{travelData[`title_${lang}`]}}</p>
          <p class="vhtml" v-html="travelData[`description_${lang}`]"></p>
          <GreenButton class="label-max-width mt-6" :label="$t('serviceArea.downloadMap')"
                       v-if="travelData.download_url"
                       @onPress="downloadMap(travelData.download_url)" />
        </v-flex>
        <v-flex xs12 md6 pl-md-12>
          <div style="width: 100%; height: 300px; position: relative">
            <div id="visit-map" style="width: 100%; height: 100%; position: relative"></div>
            <!--            <GmapMap-->
<!--                :center="travelInfo && travelInfo[0] ? { lat: travelInfo[0].lat, lng: travelInfo[0].lon } : { lat: 13.87, lng: 100.9925 }"-->
<!--                :options="mapOptions"-->
<!--                :zoom="7"-->
<!--                style="width: 100%; height: 100%"-->
<!--            >-->
<!--              <GmapMarker-->
<!--                  v-for="(m, i) in travelInfo"-->
<!--                  :key="i"-->
<!--                  :position="{ lat: m.lat, lng: m.lon }"-->
<!--                  :clickable="false"-->
<!--                  :draggable="false"-->
<!--              />-->
<!--            </GmapMap>-->

<!--            <div class="info-direction">-->
<!--              test-->
<!--            </div>-->
          </div>
<!--          <v-img contain :style="{'width': $vuetify.breakpoint.smAndDown ? '100%':'500px'}" :src="travelData.image"></v-img>-->
        </v-flex>
      </v-layout>
    </template>
    <!-- restaurant -->
    <br>
    <template v-if="restaurant">
      <v-row class="mt-5">
        <v-col
                cols="12"
                md="6"
                order="2"
                order-md="1"
                :class="{ 'pr-12': $vuetify.breakpoint.mdAndUp }"
        >
          <p class="text-tcdc-green sub-header2 bold text-uppercase">{{$t('serviceArea.restaurant')}}</p>
          <template v-if="restaurant">
            <div class="vhtml" v-html="restaurant[`description_${lang}`]"></div>
            <GreenButton class="label-max-width mt-6" :label="$t('serviceArea.downloadMap')"
                         @onPress="downloadMap(restaurant.download_url)"
                         v-if="restaurant.download_url"/>
          </template>
        </v-col>
        <v-col
                v-if="restaurant && restaurant.restaurant_details && restaurant.restaurant_details.length > 0"
                cols="12"
                md="6"
                order="2"
                order-md="1"
                :class="{ 'pl-12': $vuetify.breakpoint.mdAndUp }"
        >
<!--           <GmapMap-->
<!--                   :center="{ lat: 13.87, lng: 100.9925 }"-->
<!--                   :options="mapOptions"-->
<!--                   :zoom="7"-->
<!--                   style="width: 100%; height: 100%;"-->
<!--           >-->
<!--             <GmapMarker-->
<!--                     v-for="(m, i) in restaurant.restaurant_details"-->
<!--                     :key="i"-->
<!--                     :position="{ lat: m.lat, lng: m.lon }"-->
<!--                     :clickable="false"-->
<!--                     :draggable="false"-->
<!--                     :icon="{-->
<!--                        url: require('../../assets/icons/location-marker.png'),-->
<!--                      }"-->
<!--             />-->
<!--           </GmapMap>-->
          <img class="tcdc-visit-image" :src="restaurant.image_url" />
        </v-col>
      </v-row>
    </template>
    <!-- group visit -->
    <br>
    <template v-if="groupVisit">
      <div class="d-flex flex-column mb-15" style="gap: 20px">
        <v-row>
          <v-col cols="12" md="10">
            <p class="text-tcdc-green sub-header2 bold text-uppercase">{{$t('serviceArea.groupVisit')}}</p>
            <template v-if="groupVisit">
              <div class="vhtml" v-html="groupVisit[`description_${lang}`]"></div>
            </template>
            <GreenButton
                class="label-max-width cursor-pointer"
                :label="$t('serviceArea.groupVisitDetail')"
                @onPress="groupVisitHandler"
            />
          </v-col>
        </v-row>

        <GreenButton
            class="label-max-width cursor-pointer"
            label="VR TOUR"
            @onPress="vrTour"
        />
      </div>
    </template>
    <!--service area--->
    <template v-if="serviceArea">
      <div v-if="floorsServiceArea && floorsServiceArea.length > 1">
        <v-row>
          <v-col class="pb-0">
            <span class="text-tcdc-green sub-header2 bold text-uppercase">{{$t('serviceArea.serviceArea')}}</span>
          </v-col>
        </v-row>
        <v-row align="center" class="mb-12">
          <v-col cols="12" md="4" v-if="imageBranch">
            <img class="tcdc-visit-image" :src="imageBranch"/>
          </v-col>
          <v-col cols="12" md="6">
            <table class="tcdc-table">
              <tr class="border-tcdc-green">
                <template v-for="(item, index) of headers">
                  <th class="tcdc-table-header" :key="index.toString()">
                    <span class="text-tcdc-green" :style="{'color': index + 1 === headers.length ? 'rgb(231, 91, 31) !important':''}">{{ item[`title_${lang}`] }}</span>
                  </th>
                </template>
              </tr>
              <tr v-for="(floors,index) of floorsServiceArea" :key="index">
                <td class="visit-tcdc-border-green">
                  {{floors[0].floor ? floors[0].floor.floor_name.replace('Floor','') : ''}}
                </td>
                <td class="visit-tcdc-border-green">
                  <template v-for="(floor,key) in floors">
                    <template v-if="floor.access_type_id == 1">
                      {{floor[`name_${lang}`]}} <template v-if="key !== floors.length-1">,</template>
                    </template>
                  </template>
                </td>
                <td class="visit-tcdc-border-green" style="color: rgb(231, 91, 31);">
                  <template v-for="(floor,key) in floors">
                    <template v-if="floor.access_type_id == 2">
                      {{floor[`name_${lang}`]}} <template v-if="key !== floors.length-1">,</template>
                    </template>
                  </template>
                </td>
              </tr>
            </table>
          </v-col>
        </v-row>
        <Divider />
      </div>
      <!-- floor -->
      <div v-if="!floorsServiceArea || floorsServiceArea.length <= 1">
        <v-row>
          <v-col class="pb-0">
            <span class="text-tcdc-green sub-header2 bold text-uppercase">{{$t('serviceArea.serviceArea')}}</span>
          </v-col>
        </v-row>
      </div>
      <template v-for="(floors,index) of floorsServiceArea">
        <div :key="index" class="py-10 visit-tcdc-border-green">
          <span class="text-tcdc-green sub-header2 bold">
            {{floors[0].floor ? floors[0].floor.floor_name : ''}}
          </span>
          <v-row>
            <template v-for="(area,index) in floors">
              <v-col cols="12" md="4" :key="index">
                <FloorCard
                        :slides="area.slide_images"
                        :title="area[`name_${lang}`]"
                        :content="area[`description_${lang}`]"
                />
              </v-col>
            </template>
          </v-row>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import Divider from "../../components/dividers/Divider";
import FloorCard from "../../components/cards/FloorCard";
import { mapState } from 'vuex';
import { mapStyles } from "../../config";

export default {
  components: {
    GreenButton,
    Divider,
    FloorCard
  },
  computed: {
    ...mapState({
      serviceArea : state=>{
        return state.ServiceMenu.service_area;
      },
      travelInfo : state =>{
        return state.ServiceMenu.travel_info;
      },
      restaurant : state =>{
        return state.ServiceMenu.restaurant;
      },
      location : state =>{
        return state.ServiceMenu.location;
      },
      groupVisit : state=>{
        return state.ServiceMenu.group_visit;
      },
      floorsServiceArea : state=>{
        return state.ServiceMenu.service_area_floors;
      },
      lang: state => state.Branch.lang,
      branchChange: state => state.Branch.branch_id,
      tagName: state => state.Branch.tag_name,
      googlePlace: state => state.ServiceMenu.travel_info[0]?.google_place_id
    }),
    imageBranch(){
      let image = '';
      if(this.serviceArea && this.serviceArea.branch){
        image = this.serviceArea.branch.service_area_image;
      }
      return image;
    }
  },
  created() {
    if(this.travelInfo.length > 0){
      this.travelData = this.travelInfo[0];
      this.travel_id =  this.travelInfo[0].id
    }
  },
  mounted() {
    this.$nextTick(async () => {
      await new Promise((res, rej) => setTimeout(res, 200))
      window.addEventListener('load', this.initMap());
    })
  },
  watch: {
    branchChange: async function () {
      if (this.travelInfo && this.travelInfo.length > 0) {
        await new Promise(x => setTimeout(x, 300));
        this.travel_id = this.travelInfo[0].id;
        this.travelData = this.travelInfo[0];
      }
    },
    googlePlace: function () {
      this.initMap()
    }
  },
  methods: {
    groupVisitHandler() {
      this.$router.push(`/${this.lang}/${this.tagName}/service/visit-and-service-area/group-visit-detail`);
    },
    downloadMap(url) {
      if(url){
        window.open(url);
      }
    },
    setTravelData(travel){
      if (travel) {
        this.travelData = travel;
        this.travel_id = travel.id;
      }
    },
    vrTour () {
      window.open('https://3dvista.cea.or.th/')
    },
    async initMap () {

      if (this.googlePlace) {
        this.$nextTick(() => {
          document.getElementById('visit-map').innerHTML = this.googlePlace
        })
      }

      // // The location
      // const position = this.travelInfo && this.travelInfo[0] ? { lat: this.travelInfo[0].lat, lng: this.travelInfo[0].lon } : { lat: 13.87, lng: 100.9925 };
      // // Request needed libraries.
      // const { Map } = await google.maps.importLibrary("maps");
      // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      //
      // this.visitMap = new Map(document.getElementById("visit-map"), {
      //   zoom: 17,
      //   center: position,
      //   disableDefaultUI: false,
      //   mapId: "visit_map"
      // });
      //
      // // The markers
      // for (const p of this.travelInfo) {
      //   new AdvancedMarkerElement({
      //     map: this.visitMap,
      //     position: {
      //       lat: p.lat,
      //       lng: p.lon
      //     },
      //     title: "Location"
      //   });
      //
      //   if (p.google_place_id) {
      //     const service = new google.maps.places.PlacesService(this.visitMap);
      //     service.getDetails({
      //       placeId: p.google_place_id // Replace with the actual place ID of the location
      //     }, (place, status) => {
      //       if (status === google.maps.places.PlacesServiceStatus.OK) {
      //         // Create a custom place card
      //         let div = document.createElement('div')
      //         div.setAttribute('id', 'visit-place-card' )
      //         document.getElementById("visit-map").appendChild(div)
      //
      //         var placeCard = document.getElementById('visit-place-card');
      //         placeCard.innerHTML =
      //             '<div class="map-container">' +
      //             '    <div class="placeDiv">' +
      //             '        <div class="placecard__container">' +
      //             '          <div class="placecard__left">' +
      //             '            <p class="placecard__business-name">' + place.name + '</p>' +
      //             '            <p class="placecard__info">' + place.formatted_address + '</p>' +
      //             '          </div>' +
      //             '          <div class="placecard__right">' +
      //             '              <a class="placecard__direction-link" target="_blank" href="' + place.url + '">' +
      //             '                  <div class="placecard__direction-icon"></div>' +
      //             '                  ' + this.$t('about.directions') +
      //             '              </a>' +
      //             '          </div>' +
      //             '        </div>' +
      //             '    </div>' +
      //             '</div>'
      //       }
      //     })
      //   }
      // }
    }
  },
  data: () => ({
    headers: [
      {
        title_th: "ชั้น",
        title_en: "FL"
      },
      {
        title_th: "สาธารณะ",
        title_en: "Public"
      },
      {
        title_th: "สำหรับสมาชิก",
        title_en: "Only for member"
      }
    ],
    travelData: null,
    visitMap: undefined,
    travel_id: 1,
    mapOptions: {
      ...mapStyles,
      clickableIcons: true
    }
  })
};
</script>

<style lang="scss" scoped>
.tcdc-table {
  width: 100%;
  border-collapse: collapse;
}
.tcdc-table-header {
  text-align: left;
}
tr.border-tcdc-green {
  border-bottom: 2px solid $tcdcGreen;
}
tr.border-tcdc-green:last-child {
  border-bottom: 0px solid white;
}
td{
  padding: 10px;
}
td:first-child {
  white-space: nowrap;
}
th {
  padding: 10px;
  white-space: nowrap;
}
.tcdc-visit-image {
  width: 100%;
  object-fit: contain;
}
.label-max-width {
  max-width: 250px;
}
.visit-tcdc-border-green {
  border-bottom: 2px solid $tcdcGreen;
  color: $tcdcGreen;
}
/*.visit-tcdc-border-green:last-child {*/
/*  border-bottom: 0px solid white !important;*/
/*}*/
.transport-logo {
  width: 30px;
  object-fit: contain;
}

//.info-direction {
//  position: absolute;
//  top: 8px;
//  left: 8px;
//  padding: 8px;
//  background: #fff;
//  font-size: 13px;
//  box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
//  border-radius: 2px;
//}
</style>
